export default __webpack_public_path__ + "static/logo-0424f5f344b0b86518772efb5660bec4.png";